import * as types from './generalActionTypes.js';

export const setSystemParameters = (systemParameters) => ({ type: types.SET_SYSTEMPARAMETERS, systemParameters: systemParameters });


